export enum ScheduleOrderStatus {
    Active = 1,
    Inactive = 2
}